import React from "react";
import { OverlayTrigger, Popover } from "react-bootstrap";
import "./index.scss";
import { useWindowSize } from "../../../../hooks/use-device-type";

export interface SvgCompTeachProps {}

export function SvgCompTeach(props: SvgCompTeachProps) {
  const { isMobile } = useWindowSize();
  const placement = isMobile ? "top" : "top-start";

  return (
    <OverlayTrigger
      placement="top-start"
      // show={true}
      overlay={
        <Popover id="svg-comp-teach">
          <Popover.Body>
            <h3>核心：教师资源和教材资源</h3>

            <ul>
              <li>可调集国际顶级教材资源和国内优秀高校专家、学者。</li>
            </ul>
          </Popover.Body>
        </Popover>
      }
    >
      <g className="svg-comp-piece">
        <path
          fill="#92d050"
          d="M370.5-.5h2a3866.378 3866.378 0 0 1-3 108 11994.903 11994.903 0 0 0-91.5 49c-.667-1-.667-2 0-3a365.73 365.73 0 0 0 9.5-15.5c-56.366-5.646-100.366 14.854-132 61.5a11799.363 11799.363 0 0 1-20-72.5 1520.082 1520.082 0 0 1-79-18.5C116.834 34.85 194.834.683 290.5 6a275.459 275.459 0 0 1 67 14.5 113.306 113.306 0 0 0 13-21Z"
          style={{
            opacity: 0.991
          }}
        />
        <text x={200} y={100} fontSize={60} fill="#fff" fontWeight={"bold"}>
          教
        </text>
      </g>
    </OverlayTrigger>
  );
}
